var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgObj3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 167,
    viewBox: "0 0 95 167",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.7829 142.335L91.8233 127.527V101.275L46.7178 126.454V153.174L65.7829 142.335Z",
    stroke: "#B2C8CF",
    strokeWidth: 0.837859,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0508 128.323L24.3059 112.381L46.7179 126.454V153.174L36.4091 146.797",
    stroke: "#B2C8CF",
    strokeWidth: 0.837859,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3613 97.4912L91.8241 101.276",
    stroke: "#B2C8CF",
    strokeWidth: 0.837859,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6064 102.925L67.5506 87.2617L85.9847 97.843",
    stroke: "#B2C8CF",
    strokeWidth: 0.837859,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5264 112.167L41.0166 102.681",
    stroke: "#B2C8CF",
    strokeWidth: 0.837859,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2656 132.256L26.4299 126.521C28.4498 124.886 31.0249 124.097 33.614 124.322C40.2571 124.946 42.2362 131.512 42.7529 134.659C43.1927 137.777 42.7529 141.34 40.0812 144.011C37.4094 146.683 33.8471 148.018 33.8471 148.018",
    stroke: "#B2C8CF",
    strokeWidth: 0.837859,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3097 138.608L25.9637 144.706V165.671L1.11523 151.325V130.472L15.3097 138.608Z",
    stroke: "#B2C8CF",
    strokeWidth: 0.837859,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4034 141.011L22.5758 146.795V159.373L4.21875 148.866V136.35L12.4034 141.011Z",
    stroke: "#B2C8CF",
    strokeWidth: 0.837859,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0781 129.398L33.6776 140.501V156.831",
    stroke: "#B2C8CF",
    strokeWidth: 0.837859,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6784 156.84L25.9688 165.68",
    stroke: "#B2C8CF",
    strokeWidth: 0.837859,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0785 129.398L1.10449 130.472",
    stroke: "#B2C8CF",
    strokeWidth: 0.837859,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9688 144.715L33.6784 140.511",
    stroke: "#B2C8CF",
    strokeWidth: 0.837859,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4316 134.786V123.081L83.6012 111.105L83.7991 122.96L62.4316 134.786Z",
    stroke: "#B2C8CF",
    strokeWidth: 0.837859,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7962 100.042L25.7441 91.2041V103.925L32.2201 107.789",
    stroke: "#B2C8CF",
    strokeWidth: 0.837859,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1469 101.44L40.6885 99.9932",
    stroke: "#B2C8CF",
    strokeWidth: 0.837859,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0979 84.7966L49.5765 94.9559V110.087L47.0234 108.449V92.6579L63.0562 83L67.0979 84.7966ZM67.0979 84.7966V101.326L64.38 100.117L64.3338 86.393",
    stroke: "#B2C8CF",
    strokeWidth: 0.837859,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgObj3);
export default __webpack_public_path__ + "static/media/obj_3.34665660e1cf275236b1a7d342465c5d.svg";
export { ForwardRef as ReactComponent };